import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { isLogin } from '../../utils/auth';
import UserService from '../../service/User';
import Footer from '../components/footer/Footer';
import Menu from '../components/menu/Menu';
import ServiceCard from './components/ServiceCard';
import PageTop from '../components/pageTop/PageTop';
import { useModal } from '../../context/ModalContext';
import { copyUrl } from '../../utils/url';

function FreeTrial3() {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  const [openMenu, setOpenMenu] = useState(false);
  const [videoIndex, setVideoIndex] = useState(0);
  const [ended, setIsEnd] = useState<boolean | null>(null);
  const videoList = [
    'https://drive.google.com/file/d/1VrmVHqMorU5WdLd1vvfmB7ZnXvOq2qWH/preview',
    'https://www.youtube.com/embed/2K1QcDpFdxo',
  ];

  const getUserInfo = async () => {
    try {
      const res = await UserService.userInfo();
      const endDateStr = res.data.freeTrialSubscription.endDate;

      console.log(endDateStr);
      const endDate = new Date(endDateStr);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      endDate.setHours(0, 0, 0, 0);

      const hasEnded = endDate < today;

      setIsEnd(hasEnded);
    } catch (error) {
      console.error('userInfo 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    if (isLogin()) {
      getUserInfo();
    }
  }, []);

  return (
    <Container>
      <PageTop logo={true} />
      <BottomButton
        disabled={isLogin()}
        onClick={() => {
          if (!isLogin()) {
            navigate('/login');
          }
        }}
      >
        {ended === null
          ? `3일 0원 체험하기 >`
          : ended
            ? '이미 참여 완료한 이벤트입니다'
            : '현재 3일 무료 체험 중입니다'}
      </BottomButton>

      <MainContent>
        <MainImg>
          <Header>
            {isLogin() && (
              <InquireButton onClick={() => modalDispatch({ type: 'I' })}>
                <img
                  src="/assets/images/icon/inquire-black.svg"
                  alt=""
                  width={24}
                  height={24}
                />
                문의하기
              </InquireButton>
            )}
            <ShareIcon onClick={() => copyUrl()}>
              <img
                src="/assets/images/promotion/free/Share.svg"
                alt=""
                width={24}
                height={24}
              />
            </ShareIcon>
          </Header>
        </MainImg>

        <Content>
          <IntroContentTitle>
            가입만하면 누구나
            <img
              src="/assets/images/promotion/free/3day/text-img1.svg"
              alt="3일 무료체험!"
            />
          </IntroContentTitle>
          <VideoWrapper>
            {videoList.map((item, idx) => (
              <React.Fragment key={item}>
                {idx === 0 ? (
                  <video
                    controls
                    style={{ borderRadius: '16px' }}
                    poster="/assets/images/promotion/free/video_thumbnail.PNG"
                  >
                    <source
                      src="/assets/images/promotion/free/introduce_zipgoai.mp4"
                      type="video/mp4"
                    />
                    브라우저가 video 태그를 지원하지 않습니다.
                  </video>
                ) : (
                  <iframe
                    title="lading-algo"
                    src="https://www.youtube.com/embed/2K1QcDpFdxo"
                    style={{ borderRadius: '16px' }}
                  />
                )}
              </React.Fragment>
            ))}
          </VideoWrapper>
          <IntroduceZipgoBox>
            땅집고옥션?
            <IntroduceDescription>
              땅집고옥션은 국내 최초
              <br />
              부동산 경공매 퀀트 서비스입니다.
            </IntroduceDescription>
          </IntroduceZipgoBox>
        </Content>
      </MainContent>

      <Content backgroundColor="#1D093C">
        <ServiceDescripSectionTitle>
          땅집고옥션 가입만 하면
          <br />
          이벤트 기간 동안 <Highlight>모든 서비스 무료</Highlight>
        </ServiceDescripSectionTitle>
        <Column gap={24} center>
          <ServiceCard />
          <SubText>
            *위 기능은 로그인한 회원 전용이며 일부 서비스 및 기능은 적용
            대상에서 제외될 수 있는 점 양해 부탁드립니다.
          </SubText>
        </Column>
        <TextButton
          onClick={() => {
            window.open(`/guide`, '_blank');
          }}
        >{`땅집고옥션 이용가이드 보러가기  >`}</TextButton>
      </Content>

      <CoverContent>
        <ContentWrapper>
          <BenefitTitleWrapper>
            회원가입하자마자
            <Row gap={8} center>
              <BenefitTitleBold>아래 혜택들이</BenefitTitleBold>
              <img
                src="/assets/images/promotion/free/3day/text-img2.svg"
                alt="3일간 모두 무료!"
              />
            </Row>
          </BenefitTitleWrapper>
          <Column gap={8} center>
            <BenefitWrapper>
              <BenefitBox style={{ paddingTop: '32px' }}>
                AI 경공매 찾기 <br />
                챗봇 탐색
                <br />
                (30건)
                <AIMockupImg
                  src="/assets/images/promotion/free-trial-ai2.png"
                  alt=""
                />
              </BenefitBox>
              <BenefitRowWrap>
                <BenefitBox>
                  <BenefitIcon>
                    <img
                      src="/assets/images/promotion/free/3day/quant.svg"
                      alt=""
                    />
                  </BenefitIcon>
                  VIP 퀀트 분석 <br />
                  리포트 체험권
                  <br />
                  (10건)
                </BenefitBox>
                <BenefitBox>
                  <BenefitIcon>
                    <img
                      src="/assets/images/promotion/free/3day/algo.svg"
                      alt=""
                    />
                  </BenefitIcon>
                  경매 알고리즘 <br />
                  생성 및 분석
                  <br />
                  (10건)
                </BenefitBox>
              </BenefitRowWrap>
              <BenefitRowWrap>
                <BenefitBox>
                  <BenefitIcon>
                    <img
                      src="/assets/images/promotion/free/3day/search.svg"
                      alt=""
                    />
                  </BenefitIcon>
                  경공매 <br />
                  종합검색
                  <br />
                  무제한
                </BenefitBox>
                <BenefitBox>
                  <BenefitIcon>
                    <img
                      src="/assets/images/promotion/free/3day/searchDetail.svg"
                      alt=""
                    />
                  </BenefitIcon>
                  물건 상세분석 <br />
                  열람
                  <br />
                  (30건)
                </BenefitBox>
              </BenefitRowWrap>
            </BenefitWrapper>
            <SubText2>*회원가입 후 3일 무료체험 자동 적용됩니다.</SubText2>
          </Column>
          <BenefitContentButtonBox>
            <ConfirmButton
              $disable={isLogin()}
              onClick={() => {
                if (isLogin()) return;
                navigate('/login');
              }}
            >
              {isLogin()
                ? '신규회원만 참여가능한 이벤트입니다'
                : '지금 무료체험 신청하기 >'}
            </ConfirmButton>
          </BenefitContentButtonBox>
        </ContentWrapper>
      </CoverContent>

      <FooterContainer>
        <FooterTitle>3일 무료체험 이벤트 유의사항</FooterTitle>
        <FooterDescription>
          <FooterDescriptionItem>
            <div>・</div>
            ‘3일 무료체험’ 이벤트 기간 : 상시
          </FooterDescriptionItem>
          <FooterDescriptionItem>
            <div>・</div>본 이벤트는 땅집고옥션 회원이라면 누구나 참여
            가능합니다.
          </FooterDescriptionItem>
          <FooterDescriptionItem>
            <div>・</div>
            로그인 회원만 참여 가능하며 1개의 아이디 당 1회 3일간 사용
            가능합니다.
          </FooterDescriptionItem>
          <FooterDescriptionItem>
            <div>・</div>
            회원가입한 즉시 3일 무료체험이 시작됩니다.
          </FooterDescriptionItem>
          <FooterDescriptionItem>
            <div>・</div>
            이미 사용한 회원은 재신청 및 추가 기간 연장이 되지 않습니다.
          </FooterDescriptionItem>
          <FooterDescriptionItem>
            <div>・</div>
            3일 무료체험 일부 서비스는 제외되니 멤버십 페이지에서 확인 후
            체험하시길 바랍니다.
          </FooterDescriptionItem>
          <FooterDescriptionItem>
            <div>・</div>본 이벤트는 별도 고지 없이 변경 및 종료될 수 있습니다.
          </FooterDescriptionItem>
        </FooterDescription>
      </FooterContainer>
      <Footer />
    </Container>
  );
}

export default FreeTrial3;

const Container = styled.div`
  background: #f7feff;
  user-select: none;
`;

const MainImg = styled.div`
  position: relative;
  background-image: url('/assets/images/promotion/free/3day/topbg.png');
  background-size: cover;
  background-position: center;
  width: 100%;
  aspect-ratio: calc(360 / 600);
`;

const MainContent = styled.div`
  width: 100%;
  background: linear-gradient(180deg, #220a4a 0%, #792cf3 100%);
`;

const Content = styled.div<{
  backgroundColor?: string;
  paddingTop?: number;
  paddingBottom?: number;
}>`
  display: flex;
  flex-direction: column;
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 64px 16px;
  align-items: center;
  justify-content: center;
  gap: 40px;
`;

const IntroContentTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  font-family: Paperlogy;
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;
  text-align: center;
  color: #ffffff;
`;

const VideoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > video,
  & > iframe {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
  }
`;

const IntroduceZipgoBox = styled.div`
  width: 100%;
  border-radius: 16px;
  gap: 8px;
  padding: 16px;
  background: #ffffff33;

  font-family: 'Jalnan 2';
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  color: #ffffff;
`;

const IntroduceDescription = styled.div`
  font-family: Paperlogy;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #ffffff;
`;

const ServiceDescripSectionTitle = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #fff;
`;

const Highlight = styled.span`
  font-family: 'Paperlogy';
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  color: #a167ff;
`;

const SubText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #ffffff9c;
`;

const SubText2 = styled(SubText)`
  color: #2222229c;
`;

const CoverContent = styled.div`
  background-image: url('/assets/images/promotion/free/3day/bg.png');
  background-size: cover;
  background-position: center;
  width: 100%;
  padding-top: 240px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-left: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Column = styled.div<{ gap?: number; center?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};
  align-items: ${({ center }) => center && 'center'};
`;

const Row = styled(Column)`
  flex-direction: row;
`;

const TextButton = styled.button`
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  border-radius: 16px;
  background-color: #792cf3;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;

  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  border-radius: 16px;

  background: #f6f0ffd9;
  box-shadow: 4px 4px 24px 0px #00000040;
  backdrop-filter: blur(12px);
  width: 100%;
`;

const BenefitTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;

  font-family: Paperlogy;
  font-weight: 500;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
`;

const BenefitTitleBold = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 24px;
  line-height: 145%;
  white-space: nowrap;
`;

const Inner = styled(Column)`
  width: 1200px;
  justify-content: center;
  align-items: center;
`;

const BenefitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const BenefitBox = styled.div`
  display: flex;
  padding: 16px 16px 32px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 16px;
  background-color: #fff;
  width: 100%;
  position: relative;
  overflow: hidden;

  color: #2d0d5f;
  font-family: Paperlogy;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const AIMockupImg = styled.img`
  width: 130px;
  height: 234px;
  aspect-ratio: 5/9;
  position: absolute;
  right: 28px;
  bottom: -122px;
`;

const BenefitIcon = styled.div`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #f4f2f7;

  & > img {
    width: 28px;
    height: 28px;
  }
`;

const BenefitRowWrap = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

const BenefitContentButtonBox = styled.div`
  width: 100%;
  padding: 0 8px;
`;

const ConfirmButton = styled.div<{ $disable?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  border-radius: 16px;

  background-color: ${({ $disable }) => ($disable ? '#FAFAFB' : '#792CF3')};
  cursor: ${({ $disable }) => ($disable ? 'default' : 'pointer')};

  font-family: Paperlogy;
  font-weight: 600;
  font-size: 16px;
  line-height: 145%;
  color: ${({ $disable }) => ($disable ? '#616161' : '#fff')};
`;

const BottomButton = styled.a<{ disabled?: boolean }>`
  width: 100%;
  text-decoration: none;
  padding: 16px 10px;
  position: fixed;
  z-index: 2000;
  bottom: 0;
  left: 0;

  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: ${({ disabled }) => (disabled ? '#616161' : '#ffffff')};
  background: ${({ disabled }) => (disabled ? '#DFE1EB' : '#008aff')};

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

const Header = styled.div`
  width: 100%;
  height: 56px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;

const InquireButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;

  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
`;

const ShareIcon = styled.div<{ isEmpty?: boolean }>`
  width: 24px;
  height: 24px;
  cursor: ${({ isEmpty }) => (isEmpty ? 'default' : 'pointer')};
  align-items: center;
  justify-content: center;
`;

const IntroduceColBox = styled(Column)`
  padding: 24px 0;
  justify-content: space-between;
`;

const Dot = styled.div<{ selected: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ selected }) => (selected ? '#fff' : '#FFFFFF9C')};
  cursor: pointer;
  transition: background-color 0.3s;
`;

const DotWrapper = styled.div`
  flex-direction: row;
  gap: 8px;
`;

const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  padding: 60px 20px;
  background: #1f1f1f;
`;

const FooterTitle = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #ffffff;
`;

const FooterDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #b0b0b0;

  span {
    font-weight: 500;
    font-size: 12px;
  }
`;

const FooterDescriptionItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  color: #b0b0b0;
`;
